import { matchPath, useLocation, useParams, useNavigate } from "react-router-dom";


export function getPageParams(path) {

    const location = useLocation();
    const navigate = useNavigate();
    const urlParams = useParams();

    const pageParamsMapping = {
        "/": {
            title: "Dashboard"
        },
        "/account": {
            title: "Account"
        },
        "/billing": {
            title: "Billing"
        },
        "/consumers": {
            title: "Consumers"
        },
        "/consumers/:consumer_id": {
            title: `Consumer #${urlParams.consumer_id?.toUpperCase() || ''}`,
            onBack: () => navigate("/consumers"),
        },
        "/members": {
            title: "Members"
        },
        "/settings": {
            title: "Settings"
        },
        "/license": {
            title: "License Keys"
        },
        "/blacklist":{
            title: "Blacklist",
        },
        "/manual_review": {
            title: "Manual review"
        },
        "/manual_review/:session_id": {
            title: `Session #${urlParams.session_id}`,
            onBack: () => navigate("/manual_review"),
        },
        "/transactions": {
            title: "Transactions"
        },
        "/transactions/:service_name/:transaction_id": {
            title: `Transaction #${urlParams.transaction_id}`,
            onBack: () => navigate("/transactions"),
        },
        "/transactions/:flow_id": {
            title: `Transaction #${urlParams.flow_id}`,
            onBack: () => navigate("/transactions"),
        },
        "/flows":{
            title: "Flows",
        },
    };

    const routes = Object.keys(pageParamsMapping);

    const currentRoute = routes.find((route) => (
        matchPath({ path: route }, location.pathname)
    ));

    if (currentRoute === "/" && location.pathname === "/") {
        navigate("/transactions", { replace: true });
        return pageParamsMapping["/transactions"];
    }

    return pageParamsMapping[currentRoute];
}